import * as angular from 'angular';
import { IDispatcherService, IDispatcher, IAlarmCategoriesActionsService } from '..';

export interface IAlarmCategoriesStoreService {
    getAll(): angular.IPromise<string[]>;
    getAll(force: boolean): angular.IPromise<string[]>;
}

export interface IAlarmCategoriesActionsDispatcherService extends IDispatcherService<IAlarmCategoriesStoreService> { }

export class AlarmCategoriesActionsDispatcherService implements IAlarmCategoriesActionsDispatcherService {
    static serviceId = 'alarmCategoriesActionsDispatcherService';

    static $inject = ['alarmCategoriesActionsService'];

    constructor(private _actionService: IAlarmCategoriesActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IAlarmCategoriesStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(actionService.getAll(force))
            }
        };
    }
}